import { PROPERTY_SCALE_MAX } from '../../domain/plants/plantFilters';
import { WaterIcon } from './PlantIcons';

/**
 * Water, as a count rather than as a word (SPEC-012 D-2).
 *
 * Three droplets with the plant's score filled — the approved card's own device,
 * and the one property where the scale reads at a glance. The empty third
 * droplet is not padding: this catalogue has no plant on water score 3, and a
 * meter that shortened itself to fit would hide exactly that.
 *
 * Its own component because the card and the filter sheet both draw it, and the
 * tile in the sheet has to be the same object as the row on the card — a tile
 * showing one droplet is a promise about which cards it will leave behind.
 */
export default function WaterMeter({ score, size = 15 }) {
    return (
        <span className="water-meter">
            {Array.from({ length: PROPERTY_SCALE_MAX }, (unused, step) => (
                <WaterIcon key={step} size={size} filled={step < score} />
            ))}
        </span>
    );
}
